<div class="modal-header justify-content-end">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row mb-4">
    <div class="col-sm-12 text-center">
      <b>Please select from the available Motion presets below.</b>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-4" *ngFor="let item of presets" (click)="selectPreset(item)">
      <div class="ken-burns-preset-item">
        <div class="preset-item-image">
            <video id="video-player" preload="auto" loop="loop" muted onmouseover="this.play()" onmouseout="this.pause();this.currentTime=0;">
              <source [src]="'/assets/videos/' + item.video" type="video/mp4">
            </video>
          <!--img [src]="'/assets/images/ken-burns-preset/' + item.img" /></div-->
        <div class="preset-item-title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-default" (click)="activeModal.dismiss('Close click')">{{ 'CLOSE' | translate }}</button>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/ken-burns-preset/ken-burns-preset.component.html